<div class="container">
    <div class="title">
        {{
            isEditing
                ? ('model.dialog.title.edit' | translate: { device: selectedDevice.name })
                : ('model.dialog.title.create' | translate: { device: selectedDevice.name })
        }}
    </div>
    <div class="content-container">
        <div class="required-fields">
            <div class="input-container">
                <div class="input-title">
                    {{ 'model.dialog.model-name.title' | translate }}
                </div>
                <app-channel-text-input
                    name="model"
                    label="model.dialog.model-name.label"
                    [value]="modelName"
                    (onInputChange)="onModelNameChange($event)"
                    (onFocusChange)="onModelNameChange($event)"
                    [inputError]="validationErrors?.name"></app-channel-text-input>
            </div>
            <div class="input-container">
                <div class="input-title">
                    {{ 'model.dialog.item-code.title' | translate }}
                </div>
                <app-channel-text-input
                    name="itemCode"
                    label="model.dialog.item-code.label"
                    [value]="itemCode"
                    (onInputChange)="onItemCodeChange($event)"
                    (onFocusChange)="onItemCodeChange($event)"
                    [inputError]="validationErrors?.code"></app-channel-text-input>
            </div>
        </div>
        <app-textarea-with-error
            class="description-textarea"
            [inputValue]="description"
            legend="model.dialog.description.label"
            propertyName="description"
            (onInputUpdated)="onDescriptionChange($event)"
            [validatorFunction]="validatorFunction()"
            [rows]="7"
            placeholder="model.dialog.description.label"
        ></app-textarea-with-error>
    </div>
    <div class="footer">
        <div class="text-button" (click)="closeDialog()">
            {{ 'dlg.cancel' | translate }}
        </div>
        <div class="text-button save-button" (click)="save()" [class.save-disable]="isSaveDisabled()">
            {{ isEditing ? ('model.dialog.edit' | translate) : ('model.dialog.create' | translate) }}
        </div>
    </div>
</div>
